import { apiService } from "./base-api-service";
import { endPoints, getDocProfileEndPoint } from "./api-constants";
import { getAuthHeader, readCookie } from "../utils/helpers";
class DocProfileAPI {
  DocProfileAPI(url) {
    return getDocProfileEndPoint(url);
  }

  generateSasUriDownload(blobContainer, fileName, newFileName) {
    const getSasUriDownloadEndPoint = this.DocProfileAPI(
      `${endPoints.docProfileService.BLOB_DOWNLOAD.replace(":blobContainer", blobContainer)
        .replace(":fileName", fileName)
        .replace(":newFileName", newFileName)}`
    );
    return apiService.get(getSasUriDownloadEndPoint, null, getAuthHeader());
  }

  createDocProfile(userId, docProfile, isnewsetup) {
    const docProfileEndPoint = this.DocProfileAPI(
      `${endPoints.docProfileService.CREATE_DOCPROFILE.replace(":userid", userId).replace(":isnewsetup", isnewsetup)}`
    );
    return apiService.post(docProfileEndPoint, docProfile, getAuthHeader());
  }

  GetCompleteDocProfile(userId) {
    const docProfileEndPoint = this.DocProfileAPI(
      `${endPoints.docProfileService.GET_COMPLETE_DOCPROFILE.replace(":userid", userId)}`
    );
    return apiService.get(docProfileEndPoint, null, getAuthHeader());
  }

  GetDocProfile(userId, docId) {
    const docProfileEndPoint = this.DocProfileAPI(
      `${endPoints.docProfileService.GET_DOCPROFILE.replace(":userid", userId).replace(":docid", docId)}`
    );
    return apiService.get(docProfileEndPoint, null, getAuthHeader());
  }

  UpdateDocProfile(userId, docProfile) {
    const docProfileEndPoint = this.DocProfileAPI(
      `${endPoints.docProfileService.UPDATE_DOCPROFILE.replace(":userid", userId)}`
    );
    return apiService.put(docProfileEndPoint, docProfile, getAuthHeader());
  }
  createMultipleDocProfile(userId, docProfile, isnewsetup) {
    const docProfileEndPoint = this.DocProfileAPI(
      `${endPoints.docProfileService.MULTIPLE_DOCPROFILE.replace(":userid", userId).replace(":isnewsetup", isnewsetup)}`
    );
    return apiService.post(docProfileEndPoint, docProfile, getAuthHeader());
  }
}

export default new DocProfileAPI();
